/* eslint-disable  no-unused-vars */

import React from 'react';

import Icon from '@components/icon-component';

import style from './label.module.scss';
import icons from '@assets/icons';
import labelReconciled from '@assets/icons/labelReconciled.svg';

const Label = (
  {
    label,
    dot,
    reconciled,
    error,
    className,
    showReconciled = false,
    inLineStyle,
    inlineTextStyle
    // dangerouslySetInnerHTML = false
  },
  ref
) => {
  const dotStyling = dot
    ? `<span style="background-color: #e02b2b; width: 5px; height: 5px; display: inline-block; border-radius: 50%; margin-left: 1px;  margin-bottom: 2px;"></span>`
    : '';

  const reconciledStyles = reconciled
    ? `<img src="${labelReconciled}" style="margin-left:3px; display:inline; margin-top:-3px;" />`
    : '';

  return (
    <div className={`${style.labelWrapper} ${className}`} style={{ ...inLineStyle }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
        ref={ref}
      >
        <span className={style.labelText} style={{ ...inlineTextStyle }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              dangerouslySetInnerHTML={{
                __html: `${label} ${dotStyling} ${reconciledStyles}`
              }}
              style={{ display: 'inline' }}
            />
          </div>
        </span>
      </div>
      {error ? (
        <div
          style={{
            overflowWrap: 'break-word'
          }}
        >
          {<span className={style.error}>{error}</span>}
        </div>
      ) : (
        !error &&
        showReconciled && (
          <div
            style={{
              overflowWrap: 'break-word'
            }}
          >
            {<span className={style.reconciled}>RECONCILED</span>}
          </div>
        )
      )}
    </div>
  );
};

export default React.forwardRef(Label);
